__webpack_require__.p = "https://uat.inve.byonde.asia/";